import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Typography } from 'wanderu-components';

import ImageModal from '../ImageModal';

import styles from './MapSection.scss';

const propTypes = {
    mapDescription: PropTypes.string,
    mapHeader: PropTypes.string,
    stationMaps: PropTypes.arrayOf(PropTypes.shape({
        metadata: PropTypes.shape({
            alt: PropTypes.string,
        }),
        url: PropTypes.string,
    })),
};

const defaultProps = {
    stationMaps: [],
};

const MapSection = (props) => {
    const {
        mapDescription,
        mapHeader,
        stationMaps,
    } = props;

    const [stationImageToDisplay, setStationImageToDisplay] = useState();

    function dismissStationModal() {
        setStationImageToDisplay(undefined);
    }

    function showStationModal(index) {
        setStationImageToDisplay(index);
    }

    return (
        <>
            {stationImageToDisplay !== undefined && (
                <ImageModal
                    dismissModal={dismissStationModal}
                    image={stationMaps[stationImageToDisplay]}
                />
            )}

            <Typography
                className={styles.headerStation}
                component="h2"
                id="map-header-section"
                variant="h3"
            >
                {mapHeader}
            </Typography>

            <Typography>
                {mapDescription}
            </Typography>
            <div className={styles.mapImages}>
                {stationMaps.map((image, index) => (
                    <div className={styles.mapContainer} key={image.url}>
                        {/* eslint-disable-next-line @next/next/no-img-element */}
                        <img
                            alt={image?.metadata?.alt || ''}
                            className={styles.mapImg}
                            key={image.url}
                            onClick={() => showStationModal(index)}
                            src={image.url}
                            title={image?.metadata?.alt || ''}
                        />
                        {image?.metadata?.alt && (
                            <Typography
                                className={styles.caption}
                                variant="h6"
                            >
                                {image?.metadata?.alt}
                            </Typography>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

MapSection.propTypes = propTypes;
MapSection.defaultProps = defaultProps;

export default MapSection;
